import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EnigmaLogo from "./Components/EnigmaLogo";
import { AiFillLinkedin, AiFillGithub, AiOutlineTwitter } from "react-icons/ai";

import "./css/app.css";

export default function App() {
  const titles = ["WEB🕸️ER", "DEVELOPER", "GOPHER"];
  const [currentTitle, setCurrentTitle] = useState("");

  useEffect(() => {
    // Get the last index from localStorage
    const lastIndex = localStorage.getItem("lastTitleIndex");
    let newIndex = 0;

    if (lastIndex !== null) {
      // Calculate the next index, wrapping around when reaching the end
      newIndex = (parseInt(lastIndex, 10) + 1) % titles.length;
    }

    setCurrentTitle(titles[newIndex]); // Update the current title
    localStorage.setItem("lastTitleIndex", newIndex); // Store the new index in localStorage
  }, []);

  return (
    <div className="home">
      <section className="home-top">
        <div className="dev-title">
          <h1>DUSHYANTH</h1>
          <h1 className="red">GALI</h1>
        </div>
        <div className="enigma">
          <EnigmaLogo />
        </div>
        <div className="indicator"></div>
        <div className="links">
          <a href="https://www.linkedin.com/in/dushyanth-gali/" target="_blank">
            <div>
              <AiFillLinkedin size={25} />
            </div>
          </a>

          <a href="https://github.com/IamDushu" target="_blank">
            {" "}
            <div>
              {" "}
              <AiFillGithub size={25} />{" "}
            </div>
          </a>

          <a href="https://twitter.com/iam_dushu" target="_blank">
            {" "}
            <div>
              {" "}
              <AiOutlineTwitter size={25} />
            </div>
          </a>
        </div>
      </section>
      <section className="home-bottom">
        <div className="job-title">
          <h1>
            I'M A <br /> {currentTitle}
          </h1>
        </div>
        <div className="route">
          {/* <Link to="/about">
              <button className="btn">ABOUT</button>
            </Link> */}
          <Link to="/projects">
            <button className="btn">My Work</button>
          </Link>
          <a href="https://blog.dushyanth.in" target="_blank">
            <button className="btn">BLOG</button>
          </a>
          {/*
          <Link to="/resume">
            <button className="btn">RÉSUMÉ</button>
          </Link> */}
          {/* <Link to="/education">
            <button className="btn">EDUCATION</button>
          </Link> */}
          <Link to="/contact">
            <button className="btn">CONTACT</button>
          </Link>
        </div>
      </section>
    </div>
  );
}
